import * as React from 'react';
import { Link } from 'react-router-dom';
import { MenuItem, Nav, NavDropdown } from 'react-bootstrap';

import { BackgroundPref, NavItem, PrmService, User } from '../../../common';
import { CurrentUserService } from '../../auth';
import { BackgroundPickerModal } from './BackgroundPickerModal';
import { BackgroundPainter } from './BackgroundPainter';
import { UserSearch } from './UserSearch';
import { ErrorLogger } from '../error';

interface UserProfileProps {
  backgroundService: BackgroundPainter;
  bgPref?: BackgroundPref;
  canImpersonate: boolean;
  currentUser?: User;
  currentUserService: CurrentUserService;
  errorLogger: ErrorLogger;
  prmService: PrmService;
  userLinks?: NavItem[];
  onChangeBg(bgPref?: BackgroundPref): void;
  login(): void;
}
interface UserProfileState {
  origBgPref?: BackgroundPref;
  showModal: boolean;
}

type MenuKey = 'BACKGROUND_PICKER' | 'CLEAR_IMPERSONATION' | 'IMPERSONATE';
const MenuKeys = {
  BACKGROUND_PICKER: 'BACKGROUND_PICKER' as MenuKey,
  CLEAR_IMPERSONATION: 'CLEAR_IMPERSONATION' as MenuKey,
  IMPERSONATE: 'IMPERSONATE' as MenuKey,
};

export class UserProfile extends React.Component<UserProfileProps, UserProfileState> {
  select = async (eventKey: any | React.MouseEvent<{}>): Promise<void> => {
    switch (eventKey) {
      case MenuKeys.BACKGROUND_PICKER:
        this.setState({ showModal: true });
        break;
      case MenuKeys.CLEAR_IMPERSONATION:
        try {
          await this.props.currentUserService.clearImpersonation();
        } catch (err) {
          return this.props.errorLogger.log(err);
        }

        window.location.reload();
        break;
      default:
      // Nothing
    }
  };

  hideModal = () => {
    this.setState({ showModal: false });
    this.props.onChangeBg(this.state.origBgPref);
  };

  changeBgPref = (bgPref: BackgroundPref): void => this.props.onChangeBg(bgPref);

  saveBgPref = async (bgPref: BackgroundPref): Promise<void> => {
    try {
      await this.props.currentUserService.savePref(bgPref);

      this.setState({ origBgPref: bgPref, showModal: false });
    } catch (err) {
      return this.props.errorLogger.log(err);
    }
  };

  impersonateSearch = async (query: string): Promise<User[]> => {
    try {
      return this.props.prmService.search(query);
    } catch (err) {
      await this.props.errorLogger.log(err);
      return [];
    }
  };

  impersonate = async (user: User): Promise<void> => {
    try {
      await this.props.currentUserService.impersonate(user);

      window.location.reload();
    } catch (err) {
      return this.props.errorLogger.log(err);
    }
  };

  constructor(props: UserProfileProps) {
    super(props);

    this.state = { origBgPref: props.bgPref, showModal: false };
  }

  componentWillReceiveProps(nextProps: UserProfileProps) {
    if (nextProps.bgPref && !this.state.origBgPref) {
      this.setState({ origBgPref: nextProps.bgPref });
    }
  }

  stopClick(event: React.MouseEvent<HTMLDivElement>) {
    event.preventDefault();
    event.stopPropagation();
  }

  stopKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    event.stopPropagation();
  }

  render() {
    const currentUser = this.props.currentUser;

    if (!currentUser) {
      return (
        <ul className="nav user-profile">
          <li>
            <a href="#" onClick={this.props.login}>
              <strong>
                <i className="fa fa-sign-in" /> Login
              </strong>
            </a>
          </li>
        </ul>
      );
    }

    const canImpersonate = this.props.canImpersonate;

    return (
      <Nav className="user-profile">
        <NavDropdown
          id="user-profile"
          pullRight={true}
          title={currentUser.displayName || currentUser.name}
          onSelect={this.select}
        >
          <MenuItem eventKey={MenuKeys.BACKGROUND_PICKER}>Background Photo</MenuItem>

          {this.props.userLinks &&
            this.props.userLinks.map((userLink) => (
              <MenuItem>
                <Link to={userLink.route}>{userLink.text}</Link>
              </MenuItem>
            ))}

          {canImpersonate && !currentUser.impersonator ? (
            <MenuItem eventKey={MenuKeys.IMPERSONATE}>
              <div onClick={this.stopClick} onKeyDown={this.stopKeyDown}>
                <UserSearch
                  placeholder="Impersonate user"
                  onSearch={this.impersonateSearch}
                  onSelect={this.impersonate}
                  errorLogger={this.props.errorLogger}
                />
              </div>
            </MenuItem>
          ) : (
            ''
          )}

          {currentUser.impersonator ? (
            <MenuItem eventKey={MenuKeys.CLEAR_IMPERSONATION}>
              Clear Impersonation
              <i className="fa fa-times text-muted" />
            </MenuItem>
          ) : (
            ''
          )}
        </NavDropdown>

        <BackgroundPickerModal
          show={this.state.showModal}
          bgPref={this.props.bgPref}
          onHide={this.hideModal}
          onChange={this.changeBgPref}
          onSave={this.saveBgPref}
          backgroundService={this.props.backgroundService}
          errorLogger={this.props.errorLogger}
        />
      </Nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/client/react/layout/UserProfile.tsx